import React, { useState } from "react";
import { Region, Location } from "../types";
import "./SceneGrid.css";

interface Props {
  regions: Region[];
  onSelectLocation: (location: Location) => void;
}

export function SceneGrid({ regions, onSelectLocation }: Props) {
  const [expandedRegions, setExpandedRegions] = useState<Set<string>>(
    () => new Set(regions.map((r) => r.id)), // all open by default
  );

  const toggleRegion = (id: string) => {
    setExpandedRegions((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  return (
    <div className="scene-grid-page">
      <header className="grid-header">
        <div className="header-emblem">⚔️</div>
        <h1 className="grid-title">Legion of One Bard</h1>
      </header>

      <div className="regions-list">
        {regions.map((region) => {
          const isOpen = expandedRegions.has(region.id);
          return (
            <div key={region.id} className="region-block">
              <button
                className="region-header"
                onClick={() => toggleRegion(region.id)}
                style={
                  { "--accent": region.accentColor } as React.CSSProperties
                }
              >
                <span className="region-emoji">{region.emoji}</span>
                <span className="region-name">{region.name}</span>
                <span className="region-count">
                  {region.locations.length} locations
                </span>
                <span className={`region-chevron ${isOpen ? "open" : ""}`}>
                  ›
                </span>
              </button>

              {isOpen && (
                <div className="location-grid">
                  {[...region.locations]
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((location, i) => (
                      <button
                        key={location.id}
                        className="location-card"
                        onClick={() => onSelectLocation(location)}
                        style={
                          {
                            "--gradient": location.gradient,
                            "--accent": location.accentColor,
                            animationDelay: `${i * 30}ms`,
                          } as React.CSSProperties
                        }
                      >
                        <div className="location-card-bg" />
                        <div className="location-card-shine" />
                        <div className="location-card-content">
                          <span className="location-emoji">
                            {location.emoji}
                          </span>
                          <span className="location-name">{location.name}</span>
                        </div>
                      </button>
                    ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
